
<script lang="ts">
	import { onMount } from "svelte";
    import { Route, Router } from "svelte-navigator";

	import { Styles } from "sveltestrap";
	import RouteGuard from "./components/RouteGuard.svelte";
	import Access from "./Pages/access.svelte";
	import InfoCar from "./Pages/infoCar.svelte";
	import Login from "./Pages/login.svelte";
	import ParkingForm from "./Pages/parkingForm.svelte";
	
		onMount(updateCssVars);
	
		function updateCssVars(): void {
			window.document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
		}
	
	</script>
	
	<svelte:window on:resize={updateCssVars} />
	
	<Styles />
	
	<Router primary={false}>
	
		<Route path="/login">
			<Login />
		</Route>

		<Route path="/access/:id">
			<Access />
		</Route>

		<Route path="/">
			<RouteGuard>
				<InfoCar />
			</RouteGuard>
		</Route>
<!-- 
		<Route path="/">
			<RouteGuard>
				<SelectCar />
			</RouteGuard>
		</Route> -->
	
		<Route path="/parking/:plate">
			<RouteGuard>
				<ParkingForm />
			</RouteGuard>
		</Route>

		<Route path="/parking">
			<RouteGuard>
				<ParkingForm />
			</RouteGuard>
		</Route>
<!-- 
		<Route path="/time/:parkingId">
			<RouteGuard>
				<ParkingTime />
			</RouteGuard>
		</Route> -->

		<Route path="*">
			NotFound 
		</Route>
	</Router>
	
	